export default function LayoutAuth({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-theme-secondary p-4">
      <div className="w-full max-w-md bg-theme-main rounded-2xl p-8 shadow-lg border border-theme-secondary">
        {children}
      </div>
    </div>
  );
}
